<template>
  <div v-title="$route.meta.title"
       class="project-task-package-table">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>任务包及培训配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="project-task-package-table__card project-task-package-table__card--search">
      <div class="project-task-package-table__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="project-task-package-table__search-form"
               @submit.native.prevent="onSearch()">
        <div class="project-task-package-table__search-grid">
          <el-form-item label="项目名称"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目名称搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail"
                           :query-params="{no_ajx: 1}" />
          </el-form-item>
          <el-form-item label="项目状态"
                        prop="search_status">
            <el-select v-model="search.search_status"
                       clearable
                       placeholder="请选择"
                       class="width-max">
              <el-option
                v-for="item in projectStatusOptions"
                :key="item.key"
                :label="item.label"
                :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item label="任务包名称"
                        prop="package_title">
            <el-input v-model="search.package_title"
                      placeholder="请输入任务包名称"
                      clearable />
          </el-form-item>
        </div>
        <div class="project-task-package-table__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="project-task-package-table__card">
      <div class="project-task-package-table__card-header"
           @click="listExpanded = !listExpanded">
        <span>列表</span>
        <div class="project-task-package-table__card-header-actions">
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="project-task-package-table__header-action"
                     @click.stop="onRefresh()" />
          <span class="project-task-package-table__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="project-task-package-table__list-body">
        <div class="project-task-package-table__table-wrap">
          <el-table :data="table"
                    class="project-task-package-table__table"
                    style="width: 100%">
            <el-table-column prop="id"
                             label="项目ID"
                             width="88" />
            <el-table-column prop="number"
                             label="项目编码"
                             min-width="120"
                             show-overflow-tooltip />
            <el-table-column prop="name"
                             label="项目名称"
                             min-width="160"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link type="primary"
                         @click="goConfig(scope.row)">{{ scope.row.name || '-' }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="status"
                             label="项目状态"
                             width="100"
                             align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        :type="projectStatusTagType(scope.row.status)">
                  {{ formatStatus(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="所属客户"
                             min-width="160"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.customer_name }}/{{ scope.row.customerid }}
              </template>
            </el-table-column>
            <el-table-column prop="pending_task_count"
                             label="待抢单门店任务数"
                             width="140"
                             align="center" />
            <el-table-column prop="app_task_package_display"
                             label="展示状态"
                             width="110"
                             align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        :type="getDisplayStatusTagType(scope.row.app_task_package_display)">
                  {{ getDisplayStatusLabel(scope.row.app_task_package_display) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="package_title"
                             label="首页任务包名称"
                             min-width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.package_title || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="标签"
                             min-width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.flag_names && scope.row.flag_names.length">
                  <el-tag v-for="(name, idx) in scope.row.flag_names"
                          :key="idx"
                          size="mini"
                          class="project-task-package-table__tag">{{ name }}</el-tag>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="updated_at"
                             label="更新时间"
                             width="170" />
            <el-table-column fixed="right"
                             label="操作"
                             width="200"
                             align="left">
              <template slot-scope="scope">
                <div class="project-task-package-table__actions">
                  <span class="project-task-package-table__action is-edit"
                        @click="goConfig(scope.row)">任务包配置</span>
                  <span class="project-task-package-table__action is-bind"
                        @click="goTraining(scope.row)">培训配置</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import {
  getDisplayStatusLabel,
  getDisplayStatusTagType,
} from '../project-task-package.constants'

export default {
  mixins: [table],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      search: {
        projectid: null,
        search_status: null,
        package_title: null,
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      searchFieldType: {
        projectid: Number,
        search_status: Number,
        package_title: String,
      },
      getDisplayStatusLabel,
      getDisplayStatusTagType,
    }
  },
  computed: {
    ...Vuex.mapState({
      projectStatusOptions: state => state.customerProjectcost.options.project_status,
      statusOptions: state => state.customerProjectcost.options.status,
    }),
  },
  methods: {
    ...request.map(['getProjectTable', 'getProjectDetail']),
    /**
     * 兼容旧 URL：?status=20&status=50... → search_status
     */
    setSearchParams (params) {
      if (params.search_status == null && params.status != null) {
        const matched = this.findProjectStatusOption(params.status)
        if (matched) {
          params.search_status = matched.key
        }
      }
      for (const key in this.search) {
        if (this.search.hasOwnProperty(key) && params.hasOwnProperty(key)) {
          this.search[key] = params[key]
        }
      }
    },
    findProjectStatusOption (status) {
      const values = [].concat(status).map(Number)
      return (this.projectStatusOptions || []).find(item => {
        const optionValues = (item.value || []).map(Number)
        if (optionValues.length !== values.length) {
          return false
        }
        return optionValues.every(v => values.indexOf(v) !== -1)
          && values.every(v => optionValues.indexOf(v) !== -1)
      })
    },
    resolveStatusFilter (searchStatus) {
      if (searchStatus == null || searchStatus === '') {
        return null
      }
      const item = (this.projectStatusOptions || []).find(it => Number(it.key) === Number(searchStatus))
      return item ? item.value : null
    },
    getTableData (params) {
      const requestParams = Object.assign({}, params)
      const status = this.resolveStatusFilter(requestParams.search_status)
      delete requestParams.search_status
      if (status) {
        requestParams.status = status
      }
      return request.page('queryProjectTaskPackageProjects', requestParams)
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      this.onSearch()
    },
    formatStatus (status) {
      const item = (this.statusOptions || []).find(it => Number(it.value) === Number(status))
      return item ? item.label : status
    },
    projectStatusTagType (status) {
      const value = Number(status)
      // 开立
      if (value === 1) {
        return 'info'
      }
      // 审核中
      if ([20, 50, 60, 70].indexOf(value) !== -1) {
        return 'warning'
      }
      // 完成
      if (value === 30) {
        return 'success'
      }
      // 关闭
      if (value === 40) {
        return 'info'
      }
      // 已驳回
      if (value === 80) {
        return 'danger'
      }
      return ''
    },
    goConfig (row) {
      this.$router.push({name: '任务包配置', params: {projectId: row.id}})
    },
    goTraining (row) {
      this.$router.push({
        path: `/batch/table/${row.id}`,
        query: {mode: 'training_only', projectname: row.name || ''},
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.project-task-package-table {
  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .project-task-package-table__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    margin-top: 16px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 16px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 0;

    ::v-deep .el-table::before,
    ::v-deep .el-table::after {
      display: none;
    }

    ::v-deep .el-table__body tr:last-child td {
      border-bottom: none;
    }
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }
    }
  }

  &__tag {
    margin: 0 4px 4px 0;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0;
  }

  &__action {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
    transition: background-color 0.15s ease;
    outline: none;
    font-family: inherit;

    &.is-edit {
      color: #606266;
      border: 1px solid #909399;
    }

    &.is-bind {
      color: #2563eb;
      border: 1px solid #3b82f6;
    }

    &:hover {
      background: #f9fafb;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

@media (max-width: 1200px) {
  .project-task-package-table {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .project-task-package-table {
    &__search-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.project-task-package-table__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project-task-package/pages/ProjectTaskPackageTable.vue